import React, { useState, useEffect } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import MessageStatus from '../../List/Components/MessageStatus';
import { service } from '../../../../_services/conversation.service'
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../../_actions/alert.actions';
import { Can } from '../../../../_contexts/AbilitiesContext';

export default function Status({ conversation }) {
  const dispatch = useDispatch();
  const [data, setData] = useState({})
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    setData({...conversation})
  }, [conversation])

  const markAsRead = () => {
    setSubmitting(true)

    service.clientRead(data.id)
      .then(response => {
        setData({ ...data, read: true })
      })
      .catch(() => {
        dispatch(alertActions.error('Could not mark as read at this time. Please try again later'))
      })
      .then(() => {
        setSubmitting(false)
      })
  }

  const handleTooltipText = () => {
    if (!data.read) {
      return 'Message is unread until responded to'
    } else if (data.status === 'closed') {
      return 'Message is closed for communication'
    }
    return 'Message is open for communication'
  }

  return <div className="d-flex align-items-baseline">
    <OverlayTrigger
      overlay={<Tooltip>
        {handleTooltipText()}
      </Tooltip>}
    >
      <div><MessageStatus conversation={data} /></div>
    </OverlayTrigger>

    <Can I="set-read" a="messages">
    { !data.read &&
      <button
        onClick={markAsRead}
        disabled={submitting}
        style={{ borderRadius: '16px', fontSize: '12px', marginLeft: '15px' }}
        className='btn btn-primary'
      >
        {submitting ? <i className="fa fa-spinner fa-spin fa-fw"></i> : 'Mark as Read'}        
      </button>
    }
    </Can>    

  </div>
}